import { defineMessages } from 'react-intl';

export const messages: {
    relationshipsCreatedLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; description: {
        id: string;
        defaultMessage: string;
        description: string;
    }; explorerPlaceholderAlt: {
        id: string;
        defaultMessage: string;
        description: string;
    }; expandLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; modalTitle: {
        id: string;
        defaultMessage: string;
        description: string;
    }; closeLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; modalDescription: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	relationshipsCreatedLabel: {
		id: 'twg-microsite-experience.v2.graphPreview.relationshipsCreatedLabel',
		defaultMessage: 'Relationships created',
		description: 'Label beneath the large relationships number in the graph preview section',
	},
	description: {
		id: 'twg-microsite-experience.v2.graphPreview.description',
		defaultMessage:
			'As you work, the Teamwork Graph maps the links between your projects, people, and apps. Explore your connected workspace in the preview below.',
		description: 'Body text for the graph preview section',
	},
	explorerPlaceholderAlt: {
		id: 'twg-microsite-experience.v2.graphPreview.explorerPlaceholderAlt',
		defaultMessage: 'Graph explorer preview',
		description: 'Accessible alt text for the graph explorer placeholder area',
	},
	expandLabel: {
		id: 'twg-microsite.v2.graphPreview.expandLabel',
		defaultMessage: 'Expand graph preview',
		description: 'Accessible label for the button that expands the graph preview',
	},
	modalTitle: {
		id: 'twg-microsite.exploreGraph.modalTitle',
		defaultMessage: 'Graph explorer',
		description: 'Title for the modal dialog that contains the expanded graph explorer',
	},
	closeLabel: {
		id: 'twg-microsite.exploreGraph.closeLabel',
		defaultMessage: 'Close graph explorer',
		description: 'Accessible label for the button that closes the expanded graph explorer modal',
	},
	modalDescription: {
		id: 'twg-microsite.exploreGraph.modalDescription',
		defaultMessage:
			'Explore your graph in fullscreen. Press Escape or use the close button to return.',
		description:
			'Accessible description for the expanded graph explorer modal, announced by screen readers when the dialog opens',
	},
});
